export default __webpack_public_path__ + "static/media/File No. 31.1fb8ec3a.pdf";